import { getUTCOffsetString } from './getUTCOffsetString';

/**
 * Форматирует полную метку таймзоны: "Europe / Moscow (UTC +3)"
 */
export function formatTimeZoneLabel(timeZone: string, date: Date = new Date()): string {
  const readableZone = timeZone.replace('_', ' / ');
  const offsetStr = getUTCOffsetString(timeZone, date);
  return `${readableZone} (${offsetStr})`;
}
